import React from 'react';
import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
} from '@material-ui/core';
import { PaperBorder, TableFullWidthStyled } from 'share/component_css';
import { PatientCondStageFragment } from 'types.d';
import { formatDate } from 'share/utils';
import { NoDataTable } from 'components';

type Props = {
  conditions?: PatientCondStageFragment[];
  checkedAll: boolean;
  checkAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkItem: (event: React.ChangeEvent<HTMLInputElement>, item: string) => void;
  checkedList: string[];
};

export const TableTask: React.FC<Props> = ({
  conditions,
  checkedAll,
  checkAll,
  checkItem,
  checkedList,
}) => {
  return (
    <>
      <TableContainer component={PaperBorder}>
        <TableFullWidthStyled stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="left">
                <Checkbox
                  checked={checkedAll}
                  onChange={checkAll}
                  color="primary"
                />
              </TableCell>
              <TableCell align="left">Condition</TableCell>
              <TableCell>Stage</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell align="right">End Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conditions?.length === 0 && <NoDataTable colSpan={5} />}
            {conditions?.map(item => {
              return (
                <TableRow key={item._id}>
                  <TableCell align="left">
                    <Checkbox
                      onChange={e => checkItem(e, item._id)}
                      color="primary"
                      checked={checkedList.includes(item._id)}
                    />
                  </TableCell>
                  <TableCell align="left">
                    {item.condition?.name || 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.condition?.stages?.find(
                      stage => stage.stageId === item.stageId,
                    )?.name || 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item.startDate ? formatDate(item.startDate, true) : 'N/A'}
                  </TableCell>
                  <TableCell align="right">
                    {item.endDate ? formatDate(item.endDate, true) : 'N/A'}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </TableFullWidthStyled>
      </TableContainer>
    </>
  );
};
export default React.memo(TableTask);
